import "./Fleet.module.css";
import Header from "@/reusable_sections/Header";
import ExperienceUnmatchedLuxuryWithOurFleet from "./sections/ExperienceUnmatchedLuxuryWithOurFleet";
import OurPremiumVehicleSelection from "./sections/OurPremiumVehicleSelection";
import Footer from "@/reusable_sections/Footer";
export default function FleetPage() {
  return <div>
      <Header />
      <ExperienceUnmatchedLuxuryWithOurFleet />
      <OurPremiumVehicleSelection />
      <Footer />
    </div>;
}